<!-- INPUT -->
@if (!column().isCheckbox && !column().enum && !column().isDate && !column().filterSelectValuesSignal) {
  <app-form-input [formGroup]="filterFormGroup()"
                  [controlName]="getControlName(column().filterFormControl!)!"
                  [id]="getControlName(column().filterFormControl!)!"
                  [label]="column().filterFormControlLabel ?? '' |translate"></app-form-input>
}
<!-- CHECKBOX -->
@if (column().isCheckbox) {
  <app-checkbox-input [formGroup]="filterFormGroup()"
                      [controlName]="getControlName(column().filterFormControl!)!"
                      [id]="getControlName(column().filterFormControl!)!"
                      [label]="column().filterFormControlLabel ?? '' |translate"></app-checkbox-input>
}
@if (column().enum) {
  <!-- ENUM SELECT -->
  <app-enum-select [formGroup]="filterFormGroup()"
                   [clearButton]="true"
                   [controlName]="getControlName(column().filterFormControl!)!"
                   [castFunction]="column().enumCastFunction"
                   [enum]="column().enum"
                   [label]="column().filterFormControlLabel ?? ''"></app-enum-select>
}
<!-- VALUE SELECT -->
@if (column().filterSelectValuesSignal!) {
  <app-form-select [id]="column().filterFormControlLabel!"
                   [formGroup]="filterFormGroup()"
                   [filter]="true"
                   [options]="column().filterSelectValuesSignal!()"
                   [clear]="true"
                   [optionLabelSelector]="column().filterSelectValuesSelector!"
                   [optionValueSelector]="column().filterSelectValuesValueSelector"
                   [controlName]="getControlName(column().filterFormControl!)!"
                   [label]="column().filterFormControlLabel ?? ''"></app-form-select>
}
@if (column().isDate) {
  <app-datepicker [formGroup]="filterFormGroup()"
                  [controlName]="getControlName(column().filterFormControl!)!"
                  [id]="getControlName(column().filterFormControl!)!"
                  [label]="column().filterFormControlLabel ?? '' |translate"></app-datepicker>
}
